import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client/contexts'
import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { useEffect } from 'react'
import { useDownloadTheAppContext } from '../DownloadTheAppContext'

const MiddleWare = ({ children }: { children: React.ReactNode }) => {
  const { clientId } = UseClientModelContext()
  useEffect(() => {
    console.log('AppLoaded')
  }, [])

  const { enableDownload } = useDownloadTheAppContext()

  useEffect(() => {
    const refTimeOutEnableDowndolad = setTimeout(() => {
      enableDownload()
      trackEvent({
        eventName: 'No Bounce',
        clientId,
      })
      trackEvent({
        eventName: 'no-bounce',
        clientId,
      })
    }, 5000)

    return () => {
      clearTimeout(refTimeOutEnableDowndolad)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <>{children}</>
}

export default MiddleWare
